import { ApolloClient, HttpLink, InMemoryCache } from '@apollo/client';

interface ICreateApolloClient {
  graph: string;
}

export const createApolloClient = (args: ICreateApolloClient) => {
  const httpLink = new HttpLink({
    uri: args.graph,
  });

  const cache = new InMemoryCache();

  const client = new ApolloClient({
    link: httpLink,
    cache: cache,
    ssrMode: false,
  });

  return client;
};
